module.exports = __webpack_public_path__ + "img/hp-two-1.ab8fe4fa.jpg";